import { Link } from "react-router-dom";
import { Loader2, Clapperboard, X } from "lucide-react";
import { useVideoJob } from "@/context/VideoJobContext";
import { useT } from "@/i18n";

const STAGE_PCT = { queued: 5, script: 25, images_audio: 60, stitching: 85, done: 100 };
const STAGE_LABEL = {
  queued: "Queued",
  script: "Writing script",
  images_audio: "Creating images & voice",
  stitching: "Stitching video",
  done: "Done",
};

export default function VideoJobIndicator() {
  const { activeJob, clearActive } = useVideoJob();
  const { t } = useT();
  if (!activeJob) return null;

  const stage = activeJob.stage || "queued";
  const pct = STAGE_PCT[stage] || 10;
  const label = t(`stage_${stage}`) || STAGE_LABEL[stage] || stage;

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (window.confirm(t("video_dismiss_confirm") || "Dismiss this job? (Video will keep generating in the background)")) {
      clearActive();
    }
  };

  return (
    <div className="fixed bottom-5 right-5 z-40 max-w-sm" data-testid="video-job-indicator">
      <Link to="/app/video-producer" className="group block">
        <div className="bg-white border-2 border-orange-200 shadow-2xl shadow-orange-100 rounded-xl p-3 pr-2 hover:border-orange-400 transition-colors">
          <div className="flex items-center gap-3">
            <div className="relative shrink-0">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-400 via-orange-500 to-pink-500 flex items-center justify-center">
                <Clapperboard className="w-5 h-5 text-white" />
              </div>
              <Loader2 className="absolute -bottom-1 -right-1 w-4 h-4 text-orange-600 animate-spin bg-white rounded-full p-0.5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <div className="text-xs font-bold uppercase tracking-wider text-orange-600">{label}</div>
                <button
                  onClick={handleCancel}
                  data-testid="video-job-dismiss"
                  className="p-1 hover:bg-zinc-100 rounded text-zinc-400 hover:text-zinc-700"
                  aria-label="Dismiss"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              </div>
              <div className="text-sm font-semibold text-zinc-900 truncate" title={activeJob.topic}>
                {activeJob.topic}
              </div>
              <div className="mt-1.5 h-1.5 bg-zinc-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-amber-400 via-orange-500 to-pink-500 transition-all duration-700"
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
